import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import descriptionVue from './productDetail/description.vue';
var basicParameter = function basicParameter() {
  return import("./productDetail/basicParameter");
};
var logisticsInformation = function logisticsInformation() {
  return import("./productDetail/logisticsInformation");
};
//import logisticsInformation from './productDetail/logisticsInformation'
//const customParameter = ()=> import("./productDetail/customParameter")
var pictureDescription = function pictureDescription() {
  return import("./productDetail/pictureDescription");
};
var SEO = function SEO() {
  return import("./productDetail/SEO");
};
//const discount = ()=> import("./productDetail/discount")
var priceStock = function priceStock() {
  return import("./productDetail/priceStock");
};
export default {
  name: 'productDetail',
  i18n: require('./i18n-productDetail'),
  components: {
    basicParameter: basicParameter,
    logisticsInformation: logisticsInformation,
    //			customParameter,
    SEO: SEO,
    pictureDescription: pictureDescription,
    //			discount,
    priceStock: priceStock,
    descriptionVue: descriptionVue
  },
  data: function data() {
    return {
      tabKey: '1',
      productId: 0,
      specFlag: ""
    };
  },
  mounted: function mounted() {},
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var _this = this;
      var status = true;
      if (this.tabKey == 1) {
        status = _this.$refs.basicParameter.check();
      } else if (this.tabKey == 6) {
        status = _this.$refs.SEO.check();
      } else if (this.tabKey == 3) {
        status = _this.$refs.pictureDescription.check();
      } else if (this.tabKey == 2) {
        status = _this.$refs.priceStock.check();
      } else if (this.tabKey == 5) {
        status = _this.$refs.dsc.check();
      }
      if (status) {
        this.tabKey = activeKey;
      } else {
        this.$confirm({
          title: this.$t('productDetail.checkPrompt'),
          content: "",
          okText: this.$t('public.confirm'),
          cancelText: this.$t('public.cancel'),
          onOk: function onOk() {
            _this.tabKey = activeKey;
          }
        });
      }
    },
    getId: function getId(id, specFlag) {
      this.productId = id;
      this.specFlag = specFlag;
    }
  }
};